import styled from 'styled-components';

const ImageTitle = styled.div`
  text-align: center;
  margin: 35px 0 50px 0;
`;

const Image = styled.img`
  width: 205px;
  height: 255px;
`;

const SubTitle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin: 25px 0px;
`;

export { Image, ImageTitle, SubTitle };
